<template>
	<div class="home">
		<van-nav-bar
		left-arrow
		fixed
		:title="$t('printerSet.title')"
		@click-left="$router.push('/ShopSet/'+sessionStorage.actShopId)">
	</van-nav-bar>
	<van-cell-group>
		<van-cell v-if="continuous=='1'||continuous=='0'" :title="$t('printerSet.merge')">
			<van-switch :value="continuous=='1'" @input="changePrinterSet" active-color="#2f75f7" inactive-color="#ee0a24" />
		</van-cell>

		<van-cell :title="$t('printerSet.order')" :value="order.sn" is-link @click="goPrinterSet(order)" />
		<van-button class="testBtn" round  @click="testPrint(order.id)">{{$t('printerSet.testPrint')}}</van-button>

		<template v-if="firstKitchen">
			<van-cell :title="$t('printerSet.kitchen')" :value="firstKitchen.sn" is-link @click="goPrinterSet(kitchen)" />
		</template>
		<template v-for="(item,index) in kitchen">
			<van-button class="testBtn" round  @click="testPrint(item.id)">{{$t('printerSet.testPrint')}}{{item.mark}}</van-button>
		</template>

		<van-cell :title="$t('printerSet.queue')" :value="queue.sn" is-link @click="goPrinterSet(queue)" />
		<van-button class="testBtn" round  @click="testPrint(queue.id)">{{$t('printerSet.testPrint')}}</van-button>
	</van-cell-group>
</div>
</template>
<script>
	export default {
		data () {
			return {
				order:{
					sn:'',
					type:1
				},
				queue:{
					sn:'',
					type:2
				},
				kitchen:[{
					sn:'',
					type:0,
					mark:'A'
				},{
					sn:'',
					type:0,
					mark:'B'
				},{
					sn:'',
					type:0,
					mark:'C'
				},{
					sn:'',
					type:0,
					mark:'D'
				},{
					sn:'',
					type:0,
					mark:'E'
				}],
				firstKitchen:{},
				editShow:true,
				continuous:'0',//开关值
			}
		},
		mounted:function(){
			this.getShop();
		},
		methods:{
			getShop(){
				this.$axios({
					method: 'get',
					headers: {
						"Authorization": 'Bearer '+sessionStorage.token,
					},
					url: this.$build+'/api/store/'+sessionStorage.actShopId+'/show',
				}).then(res => {
					console.log(res);
					if(res.data.status==200){
						this.continuous=res.data.data.continuous;
						if(res.data.data.printers.length>0){
							let kitchenList = [];
							for (var i = 0; i < res.data.data.printers.length; i++) {
								switch(res.data.data.printers[i].type){
									case 0:
										kitchenList.push(res.data.data.printers[i]);
										break;
									case 1:
										this.order=res.data.data.printers[i];
										break;
									case 2:
										this.queue=res.data.data.printers[i];
										break;
									default:
										break;
								}
							}
							if(kitchenList.length>0){
								for( var j=0;j<kitchenList.length;j++){
									if(j==0){
										this.firstKitchen = kitchenList[j];
									}
									for (var n = 0; n < this.kitchen.length; n++) {
										if(kitchenList[j].mark == this.kitchen[n].mark){
											this.kitchen[n] = kitchenList[j];
											break;
										}
									}
								}
							}
						}
					}else{
					}
				}).catch(err => {
					this.$toast({
						type:'fail',
						message:this.$t('EditShop.message'),
					});
				});
			},
			testPrint(id){
				if(id){
					this.$axios({
						method: 'get',
						headers: {
							"Authorization": 'Bearer '+sessionStorage.token,
						},
						url: this.$build+'/api/storeprinter/'+id+'/printer',
					}).then(res => {
						console.log(res);
						if(res.data.status==200){
							this.$toast({
								type:'success',
								message:res.data.message,
							});
						}else{
							this.$toast({
								type:'fail',
								message:res.data.message,
							});
						}
					}).catch(err => {
						this.$toast({
							type:'fail',
							message:this.$t('EditShop.message'),
						});
					});
				}else{
					this.$toast({
						type:'fail',
						message:this.$t('printerSet.testTip'),
					});
				}
			},
			goPrinterSet(data){
				if(data==this.kitchen){
					sessionStorage.setItem('type',0);
					sessionStorage.setItem('printerData',JSON.stringify(data));
					this.$router.push('/PrinterSet');
				}else{
					sessionStorage.setItem('type',1);
					sessionStorage.setItem('printerData',JSON.stringify(data));
					this.$router.push('/PrinterSet');
				}
			},
			changePrinterSet(){
				var val=this.continuous=='1'?'0':'1';
	    		this.$axios({
	                method: 'PATCH',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/update',
	                data:{
	                	continuous:val,
	                },
	            }).then(res => {
	            	 console.log(res);
	            	if(res.data.status==200){
	                	this.$toast({
		            		type:'success',
		            		message:res.data.message,
		            	});
		            	this.continuous=val;
	            	}else{
	            		this.$toast.allowMultiple();
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	this.$toast({
	            		type:'fail',
	            		message:this.$t('EditShop.message'),
	        		});
	            });
			},
		},
	}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-field__left-icon .van-icon{
		font-size: 20px;
	}
	/deep/ .van-cell .van-icon{
		font-size: 20px;
	}
	/deep/ .van-field__control{
		text-align: right;
	}
	.home{
		width: 100%;
		/*height: 100vh;*/
		padding-bottom: 60px;
		background: #f3f5f7;
	}
	/deep/ .van-picker__cancel,/deep/ .van-picker__confirm{
		color:#FFC914;
	}
	/deep/ .van-cell-group{
		background: #f3f5f7;
	}
	.testBtn{
		width: 50%;
		margin: 15px 25%;
		background: #2f75f4;
		color: #fff;
	}
</style>




// WEBPACK FOOTER //
// src/Shop/PrinterList.vue